//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('currencyExRate', {
//        templateUrl: 'views/components/views/currencyExRate/currencyExRate.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'currencyExRateService', function ($stateParams, stateService, utilityService, currencyExRateService) {
//            const vm = this;
//            let currencyExRateKeyno = $stateParams.currencyexrate_keyno;
            
//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            async function loadEdit() {
//                vm.model.edit = (await currencyExRateService.getEdit({ currencyexrate_keyno: currencyExRateKeyno }))[0];
//            }

//            function recalcExchangeRateFactor() {
//                vm.model.edit.exchangerate_factor = utilityService.parseNumber(vm.model.edit.exchangerate / vm.model.edit.valuta_pr);
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                currencyExRateService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            vm.onExchangerateChanged = function (value) {
//                vm.model.edit.exchangerate = value;

//                if (value) {
//                    recalcExchangeRateFactor();
//                }
//            }

//            vm.$onInit = function () {
//                loadEdit();
//            }
//        }]
//    });
//})();
